import { Box, Flex, Stack, Text, useCheckbox, useCheckboxGroup, UseCheckboxProps } from "@chakra-ui/react";
import { Immutable } from "@hookstate/core";
import { CheckboxCheckedIcon } from "../../../../components/icons/CheckboxCheckedIcon";
import { CheckboxUncheckedIcon } from "../../../../components/icons/CheckboxUncheckedIcon";
import { Option } from "../../../../types";

interface FacetGroupFilterProps<T> {
  value: Immutable<string[] | undefined>;
  options: Option<string>[];
  onChange: (nextValue: T[]) => void;
  /** Tinted row background for sidebar filters (default). Set false for popover usage. */
  tinted?: boolean;
}
export function FacetGroupFilter<T extends string>({ value, options, onChange, tinted = true }: FacetGroupFilterProps<T>) {
  const { getCheckboxProps } = useCheckboxGroup({ value: value as (string | number)[], defaultValue: [], onChange });
  return (
    <Flex direction="column" borderRadius="8px" overflow="hidden">
      <Stack data-gc-ignore-input="1" spacing={0}>
        {options.map((option) => (
          <CustomCheckbox key={option.value} tinted={tinted} {...getCheckboxProps({ value: option.value })}>
            <Text fontFamily="Roboto" fontSize="14px" fontWeight="400" lineHeight="1.3" letterSpacing="0.5px" color={value?.includes(option.value) ? "white" : "charcoal.200"} _groupHover={{ color: "white" }}>
              {option.label}
            </Text>
          </CustomCheckbox>
        ))}
      </Stack>
    </Flex>
  );
}

interface CustomCheckboxProps extends UseCheckboxProps { children?: React.ReactNode; tinted?: boolean; }
function CustomCheckbox({ tinted = true, ...props }: CustomCheckboxProps) {
  const { state, getInputProps } = useCheckbox(props);
  const input = getInputProps();
  return (
    <Box
      display="flex" w="full" py="8px" px="8px" justifyContent="space-between" alignItems="center"
      as="label" cursor="pointer" role="group"
      {...(tinted
        ? { bg: "transparent.white.05", _hover: { bg: "transparent.white.10" } }
        : { layerStyle: "filterList" }
      )}
    >
      <input {...input} hidden />
      {props.children}
      {state.isChecked ? <CheckboxCheckedIcon color="blaze.300" boxSize="20px" /> : <CheckboxUncheckedIcon _groupHover={{ color: "transparent.white.80" }} color="transparent.white.40" boxSize="20px" />}
    </Box>
  );
}
